import { render, staticRenderFns } from "./FeaturesHistory.vue?vue&type=template&id=1b73468c&scoped=true"
import script from "./FeaturesHistory.vue?vue&type=script&lang=js"
export * from "./FeaturesHistory.vue?vue&type=script&lang=js"
import style0 from "./FeaturesHistory.vue?vue&type=style&index=0&id=1b73468c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b73468c",
  null
  
)

export default component.exports